import { createStore, combineReducers, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';

const globalReducer = (state, action) => ({});

/* Define the Reducers that will always be present in the application.
 * We need at least one reducer initially, so 'global' will be an empty reducer
 * that we can potentially use in the future if need be.
 */
const staticReducers = {
   global: globalReducer,
};

function createReducer(reducers) {
   return combineReducers({
      ...staticReducers,
      ...reducers,
   });
}

// Configure the store
export default function configureStore() {
   const store = createStore(createReducer(), composeWithDevTools(applyMiddleware(thunk)));

   // Add a dictionary to keep track of the registered async reducers
   store.reducers = {};

   // Create an inject reducer function
   // This function adds the async reducer, and creates a new combined reducer
   store.injectReducer = (key, asyncReducer) => {
      store.reducers[key] = asyncReducer;
      store.replaceReducer(createReducer(store.reducers));
   };

   // Return the modified store
   return store;
}
